var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Btn_Watch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.015,
    height: 130,
    viewBox: "0 0 168.015 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 168.015,
    height: 130,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M144.452,175.923H57.939a6.336,6.336,0,0,0,0,12.672h86.513a6.336,6.336,0,1,0,0-12.672",
    transform: "translate(-17.187 -58.595)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M149.789,0H18.226A18.226,18.226,0,0,0,0,18.227v73.42a18.226,18.226,0,0,0,18.226,18.227H149.789a18.227,18.227,0,0,0,18.227-18.227V18.227A18.226,18.226,0,0,0,149.789,0M62.5,72.974a5,5,0,0,1-3.537-8.539L92.981,30.419a5,5,0,0,1,7.073,7.074L66.041,71.508A4.989,4.989,0,0,1,62.5,72.974M100.995,57.29,87.912,70.373A5,5,0,0,1,80.839,63.3L93.921,50.216a5,5,0,1,1,7.073,7.074",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchActive);
export default __webpack_public_path__ + "static/media/watch-active.e37bf6f071400a450d6ae1d997f098ae.svg";
export { ForwardRef as ReactComponent };